export default __webpack_public_path__ + "static/media/project_japango.900b3fd9.png";